<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import { spaLink } from "../../actions"
    import MedialibImage from "../MedialibImage.svelte"
    import LinkList from "../LinkList.svelte"
    import ProductEyecatcherIntroBox from "./ProductEyecatcher_IntroBox.svelte"

    export let block: ContentBlockEntry

    let loading = false
    let products: ProductEntry[]
    let categories: CategoryEntry[]
    let categoriesMap: { [key: string]: CategoryEntry } = {}

    async function load() {
        loading = true
        products = (await getCachedEntries("product", { _id: { $in: block.productEyecatcher?.products || [] } }))?.sort(
            (a, b) => {
                return block.productEyecatcher.products.indexOf(a.id) - block.productEyecatcher.products.indexOf(b.id)
            }
        )
        categories = await getCachedEntries("category", null, "sort")
        categories.forEach((category) => {
            categoriesMap[category.ident] = category
        })
        loading = false
    }

    function html2TextTeaser(text: string): string {
        return text?.replace(/<[^>]*>?/gm, "").substring(0, 70) || ""
    }

    load()
</script>

<section class="container-offset tp-l bp-l hardware-row">
    <!-- .container-offset um die Bündigkeit des Texts herzustellen, .hardware-row für Styling -->
    <div class="grid vp-xl hp-xl border-radius-all border-radius-m product-cards">
        {#if !block.productEyecatcher?.hideIntroBox && (!block.productEyecatcher?.introBox?.position || block.productEyecatcher.introBox.position == "left")}
            <ProductEyecatcherIntroBox introBox="{block.productEyecatcher?.introBox}" />
        {/if}
        {#each products || [] as product}
            <article class="col-auto">
                <div class="product-card">
                    <!-- .product-card für die jeweiligen Produkte -->
                    <header>
                        <img
                            class="background-detail"
                            src="/assets/img/products-detailheader.jpg"
                            alt="Product Detail"
                        />
                        {#if product.teaserimage}
                            <figure>
                                <MedialibImage id="{product.teaserimage}" />
                            </figure>
                        {/if}
                        {#if product.lines?.length}
                            <ul class="type-grid">
                                {#each product.lines as lineIdent}
                                    <li>
                                        <figure>
                                            <img src="assets/img/{lineIdent}-logo.svg" alt="{lineIdent}" />
                                        </figure>
                                    </li>
                                {/each}
                            </ul>
                        {/if}
                    </header>
                    <div class="content">
                        <div class="badge">
                            {#each product.categories as categoryIdent}
                                {#if categoriesMap[categoryIdent]?.name}<span>{categoriesMap[categoryIdent]?.name}</span
                                    >{/if}
                            {/each}
                            {#if product.number}<span>Art.-No. {product.number}</span>{/if}
                        </div>
                        <h3>{product.title || ""}</h3>
                        <div class="description">
                            {@html html2TextTeaser(product.text)}...
                        </div>
                        <nav class="vertical">
                            <a
                                use:spaLink
                                href="/products/{product.slug || product.id}"
                                class="cta btn-secondary btn-arrow-right">More details</a
                            >
                        </nav>
                    </div>
                </div>
            </article>
        {/each}
        {#if !block.productEyecatcher?.hideIntroBox && block.productEyecatcher?.introBox?.position == "right"}
            <ProductEyecatcherIntroBox introBox="{block.productEyecatcher?.introBox}" />
        {/if}
        {#if block.productEyecatcher?.links?.length}
            <div class="button-wrap tp-s col-12">
                <LinkList links="{block.productEyecatcher.links}" />
            </div>
        {/if}
    </div>
</section>
